// /orgs/$orgSlug/projects/$projectId/review-sessions/ — the session
// list (PRD §9.10, B6 PR7 / B6g).
//
// Index child of the review-sessions layout; error handling lives on
// the parent layout's errorComponent.

import { createFileRoute } from '@tanstack/react-router';

import { ReviewSessionsPage } from '../components/ReviewSessionsPage';

export const Route = createFileRoute(
  '/orgs/$orgSlug/projects/$projectId/review-sessions/'
)({
  component: ReviewSessionsIndexRoute,
});

function ReviewSessionsIndexRoute(): React.JSX.Element {
  const { orgSlug, projectId } = Route.useParams();
  return <ReviewSessionsPage orgSlug={orgSlug} projectId={projectId} />;
}
